import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaginatedService } from '../model/pagination/paginated-service.model';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../model/pagination/paginated-response.model';
import { map } from 'rxjs/operators';
import { OwnershipClaim } from '../model/ownership-claim/ownership-claim.model';
import { HttpOptions } from '../model/http-options.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClaimRequestService implements PaginatedService<OwnershipClaim> {
  private httpClient = inject(HttpClient);

  public getPaginatedList(options: HttpOptions = {}): Observable<PaginatedResponse<OwnershipClaim>> {
    return this.httpClient.get(
      `${environment.apiUrl}/api/claim-requests`,
      options,
    ).pipe(
      map((response: any): PaginatedResponse<OwnershipClaim> => {
        const items: OwnershipClaim[] = (response?.items ?? [])
          .map((response: any): OwnershipClaim => OwnershipClaim.createFromApi(response));
        return new PaginatedResponse<OwnershipClaim>({
          ...response,
          items,
        });
      }),
    );
  }

  public getClaimRequestById(claimRequestId: string): Observable<OwnershipClaim> {
    return this.httpClient.get(`${environment.apiUrl}/api/claim-requests/${claimRequestId}`)
      .pipe(
        map((response: any): OwnershipClaim => OwnershipClaim.createFromApi(response)),
      );
  }

  public acceptClaimRequest(claimRequestId: string): Observable<void> {
    return this.httpClient.patch<void>(
      `${environment.apiUrl}/api/claim-requests/${claimRequestId}/accept`,
      {},
    );
  }

  public rejectClaimRequest(claimRequestId: string): Observable<void> {
    return this.httpClient.patch<void>(
      `${environment.apiUrl}/api/claim-requests/${claimRequestId}/reject`,
      {},
    );
  }
}
